import { render, staticRenderFns } from "./TicketSettings.vue?vue&type=template&id=3821954a&scoped=true"
import script from "./TicketSettings.vue?vue&type=script&lang=js"
export * from "./TicketSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3821954a",
  null
  
)

export default component.exports